import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
// Die Sprache (sprache.ts) steht beim Laden des Moduls fest: ?lang=, gemerkt, Browser.
import './sprache';

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
